/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadPalInfo
 */
export interface LeadPalInfo {
    /**
     * 
     * @type {boolean}
     * @memberof LeadPalInfo
     */
    execution_available: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    execution_available_reason: LeadPalInfoExecutionAvailableReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    payor_id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    insurance_type: LeadPalInfoInsuranceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LeadPalInfo
     */
    latest_execution_state: LeadPalInfoLatestExecutionStateEnum;
}


/**
 * @export
 */
export const LeadPalInfoExecutionAvailableReasonEnum = {
    LeadAnalysisInProgress: 'lead_analysis_in_progress',
    NoPrimaryCommercialInsurance: 'no_primary_commercial_insurance',
    PayorNotSupported: 'payor_not_supported',
    QuotaExceeded: 'quota_exceeded',
    Null: 'null'
} as const;
export type LeadPalInfoExecutionAvailableReasonEnum = typeof LeadPalInfoExecutionAvailableReasonEnum[keyof typeof LeadPalInfoExecutionAvailableReasonEnum];

/**
 * @export
 */
export const LeadPalInfoInsuranceTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    Null: 'null'
} as const;
export type LeadPalInfoInsuranceTypeEnum = typeof LeadPalInfoInsuranceTypeEnum[keyof typeof LeadPalInfoInsuranceTypeEnum];

/**
 * @export
 */
export const LeadPalInfoLatestExecutionStateEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Finished: 'finished',
    Null: 'null'
} as const;
export type LeadPalInfoLatestExecutionStateEnum = typeof LeadPalInfoLatestExecutionStateEnum[keyof typeof LeadPalInfoLatestExecutionStateEnum];


/**
 * Check if a given object implements the LeadPalInfo interface.
 */
export function instanceOfLeadPalInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "execution_available" in value;
    isInstance = isInstance && "execution_available_reason" in value;
    isInstance = isInstance && "payor_id" in value;
    isInstance = isInstance && "insurance_type" in value;
    isInstance = isInstance && "latest_execution_state" in value;

    return isInstance;
}

export function LeadPalInfoFromJSON(json: any): LeadPalInfo {
    return LeadPalInfoFromJSONTyped(json, false);
}

export function LeadPalInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadPalInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'execution_available': json['execution_available'],
        'execution_available_reason': json['execution_available_reason'],
        'payor_id': json['payor_id'],
        'insurance_type': json['insurance_type'],
        'latest_execution_state': json['latest_execution_state'],
    };
}

export function LeadPalInfoToJSON(value?: LeadPalInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'execution_available': value.execution_available,
        'execution_available_reason': value.execution_available_reason,
        'payor_id': value.payor_id,
        'insurance_type': value.insurance_type,
        'latest_execution_state': value.latest_execution_state,
    };
}

